module.exports = __webpack_public_path__ + "static/media/fun-zone-image.b193eb3e.png";